export default __webpack_public_path__ + "static/media/img (3).4697a2f0.jpg";